module.exports = __webpack_public_path__ + "images/saaremaa/favicon-96x96.png";